import React from 'react';
import Form from './Form';

const Card = (props) => (
    <div className="card">
        <div className="card-header">
            <div className="row align-items-center">
                <div className="col-12">
                    <h3 className="mb-0">Minha Conta</h3>
                </div>
            </div>
        </div>
        <div className="card-body">
            <Form />
        </div>
    </div>
);

export default Card;


// WEBPACK FOOTER //
// ./src/components/Pages/ChangePassword/Card.js